import { AreaDesignerManager } from '../areaDesignerManager';
import AreaDesignerPlugin from './areaDesignerPlugin';

export class AreaDesignerGridCheckerPlugin implements AreaDesignerPlugin {
    private readonly checkerSize = 10;
    private readonly checkerColor = '#eef1f3';

    private manager!: AreaDesignerManager;
    private canvas: HTMLCanvasElement | null = null;
    private positionUpdateFrame: number | null = null;

    private updateCheckerPosition = () => {
        if (!this.canvas || this.manager.mode === 'VIEWER') return;

        const tileSize = this.checkerSize * 2;
        const projectOrigin = this.manager.paper.view.projectToView(new this.manager.paper.Point(0, 0));
        const offsetX = ((projectOrigin.x % tileSize) + tileSize) % tileSize;
        const offsetY = ((projectOrigin.y % tileSize) + tileSize) % tileSize;

        this.canvas.style.backgroundPosition = `${offsetX}px ${offsetY}px`;
    };

    private scheduleCheckerPositionUpdate = () => {
        if (this.manager.mode === 'VIEWER' || this.positionUpdateFrame !== null) return;

        this.positionUpdateFrame = window.requestAnimationFrame(() => {
            this.positionUpdateFrame = null;
            this.updateCheckerPosition();
        });
    };

    public create = (manager: AreaDesignerManager) => {
        this.manager = manager;

        if (manager.mode === 'VIEWER') return;

        const tileSize = this.checkerSize * 2;
        this.canvas = manager.paper.view.element;
        this.canvas.style.backgroundColor = '#ffffff';
        this.canvas.style.backgroundImage = `conic-gradient(${this.checkerColor} 25%, #ffffff 0 50%, ${this.checkerColor} 0 75%, #ffffff 0)`;
        this.canvas.style.backgroundSize = `${tileSize}px ${tileSize}px`;
        this.canvas.style.backgroundRepeat = 'repeat';

        this.updateCheckerPosition();
    };

    public onViewMoved = () => {
        this.scheduleCheckerPositionUpdate();
    };

    public onViewZoomChanged = () => {
        this.scheduleCheckerPositionUpdate();
    };
}
